import { ComponentType } from '@angular/cdk/portal';
import { Injectable, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AlertComponent } from '../layout/dialog/alert/alert.component';
import { LoaderComponent } from '../layout/dialog/loader/loader.component';

export interface DialogButton {
  name: string;
  color?: 'primary' | 'accent' | 'warn';
  type?: 'flat' | 'stroked' | 'text';
  handler?: (data?: any) => void;
}

export interface LoaderData {
  title?: string;
  text?: string;
}

export interface DialogData extends LoaderData {
  subTitle?: string;
  buttons?: DialogButton[];
}

@Injectable()
export class DialogService {
  private loaderRef: MatDialogRef<LoaderComponent, any>;

  constructor(
    private md: MatDialog
  ) {

  }

  public open(componentOrTemplateRef: ComponentType<any> | TemplateRef<any>, config?: MatDialogConfig<any>): MatDialogRef<any, any> {
    return this.md.open(componentOrTemplateRef, config);
  }

  public loader(data: LoaderData = {}): void {
    const loaderData = {
      text: 'Bitte warten ...'
    };

    Object.assign(loaderData, data);

    if (!this.loaderRef) {
      this.loaderRef = this.open(LoaderComponent, {
        data: loaderData,
        closeOnNavigation: false,
        disableClose: true,
        hasBackdrop: true,
        panelClass: 'loader'
      });
    } else {
      this.loaderRef.componentInstance.data = loaderData;
    }

  }

  public closeLoader(): void {
    if (this.loaderRef) {
      this.loaderRef.close();
      delete this.loaderRef;
    }
  }

  public alert(data: DialogData = {}, dialogParams?: MatDialogConfig): MatDialogRef<any, any> {
    let config = {
      data,
      closeOnNavigation: false,
      disableClose: false,
      hasBackdrop: true,
      autoFocus: false
    };
    if(dialogParams) {
      config = Object.assign(dialogParams, config);
    }

    return this.open(AlertComponent, config);

  }
}
